import { GeoCoordinates } from '../serializable/geo-coordinates.js';

export class GoogleMapsPosition {
  static readonly kDefaultZoom: number = 16;

  constructor(
        public readonly latitude: number,
        public readonly longitude: number,
        public readonly zoom: number = GoogleMapsPosition.kDefaultZoom,
  ) {}

  static fromCoordinates(coordinates: GeoCoordinates): GoogleMapsPosition {
    return new GoogleMapsPosition(
        coordinates.latitude,
        coordinates.longitude,
    );
  }
}
